import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

export default function Layout({ children, alertCount }) {
  const { user, loading } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#FBF9F6] flex items-center justify-center">
        <div className="w-8 h-8 border-3 border-[#1E3F2D] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" />;

  return (
    <div className="min-h-screen bg-[#FBF9F6]">
      <Topbar onMenuToggle={() => setMobileOpen((current) => !current)} />
      <Sidebar alertCount={alertCount} mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />
      <main className="pt-[96px] pb-6 lg:ml-72 min-h-screen" data-testid="main-content">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {children}
        </div>
      </main>
    </div>
  );
}
